import { TarabutFaviconLoader } from "../../assets/gif";
import { getBankFaviconAsSvg } from "../../utils/svgUtils";
import "./styles.scss";

const BankConnectCard = ({
  heading,
  description,
  dataRowText,
  cardData,
  topButtonText,
  buttonText,
  onBtnClick,
  bankRowClassName,
  isLoading,
  disabled,
}) => {
  return (
    <>
      <div className="connect-bank-card">
        <div className="card-header">
          <div className="card-title">{heading}</div>
        </div>
        <p className="card-description">{description}</p>
        <div className={`bank-row ${bankRowClassName}`}>
          <span className="available-banks">{dataRowText}</span>
          <div className="bank-logos">
            {cardData &&
              cardData.length > 0 &&
              cardData.map((bank, index) => {
                const favicon = getBankFaviconAsSvg(bank?.providerId || bank);
                if (favicon && index < 6) {
                  return (
                    <div className="bank-logo" key={bank.providerId}>
                      <img src={favicon} alt="bank1" />
                    </div>
                  );
                }
                return null;
              })}
          </div>
        </div>
        {topButtonText ? (
          <p className="button-top-text">{topButtonText}</p>
        ) : null}
        <button
          className="connect-button"
          onClick={onBtnClick}
          disabled={disabled}
        >
          {buttonText}
          {isLoading ? (
            <img
              src={TarabutFaviconLoader}
              alt="logo loader"
              className="logo-loader"
            />
          ) : null}
        </button>
      </div>
    </>
  );
};

export default BankConnectCard;
